import InternationalBankModel from './international-bank-model';

export default class CorbanInternationalBankModel extends InternationalBankModel {
  constructor(obj) {
    obj = obj || {};
    super(obj);

    this.id = obj.id;
  }
}